import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { AuthProvider, useAuth } from "./context/AuthContext";
import LoginPage from "./pages/LoginPage";
import DashboardPage from "./pages/DashboardPage";
import SEOReportsPage from "./pages/SEOReportsPage";
import AdsReportsPage from "./pages/AdsReportsPage";
import EmailReportsPage from "./pages/EmailReportsPage";
import SEOAnnualReportPage from "./pages/SEOAnnualReportPage";
import AdsAnnualReportPage from "./pages/AdsAnnualReportPage";
import EmailAnnualReportPage from "./pages/EmailAnnualReportPage";
import AdminClientsPage from "./pages/AdminClientsPage";
import AdminReportsPage from "./pages/AdminReportsPage";
import AdminUsersPage from "./pages/AdminUsersPage";
import AdminViewReportsPage from "./pages/AdminViewReportsPage";
import Layout from "./components/Layout";
import "@/App.css";

const ProtectedRoute = ({ children, adminOnly = false }) => {
  const { user, loading } = useAuth();
  
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-50">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"></div>
      </div>
    );
  }
  
  if (!user) {
    return <Navigate to="/login" replace />;
  }
  
  if (adminOnly && user.role !== "admin") {
    return <Navigate to="/dashboard" replace />;
  }
  
  return children;
};

function AppRoutes() {
  const { user } = useAuth();
  
  return (
    <Routes>
      <Route path="/login" element={user ? <Navigate to="/dashboard" replace /> : <LoginPage />} />
      
      <Route path="/" element={
        <ProtectedRoute>
          <Layout />
        </ProtectedRoute>
      }>
        <Route index element={<Navigate to="/dashboard" replace />} />
        <Route path="dashboard" element={<DashboardPage />} />
        <Route path="seo" element={<SEOReportsPage />} />
        <Route path="ads" element={<AdsReportsPage />} />
        <Route path="email" element={<EmailReportsPage />} />
        
        {/* Annual Reports */}
        <Route path="annual/seo" element={<SEOAnnualReportPage />} />
        <Route path="annual/ads" element={<AdsAnnualReportPage />} />
        <Route path="annual/email" element={<EmailAnnualReportPage />} />
        
        {/* Admin Routes */}
        <Route path="admin/clients" element={
          <ProtectedRoute adminOnly>
            <AdminClientsPage />
          </ProtectedRoute>
        } />
        <Route path="admin/reports" element={
          <ProtectedRoute adminOnly>
            <AdminReportsPage />
          </ProtectedRoute>
        } />
        <Route path="admin/view-reports" element={
          <ProtectedRoute adminOnly>
            <AdminViewReportsPage />
          </ProtectedRoute>
        } />
        <Route path="admin/users" element={
          <ProtectedRoute adminOnly>
            <AdminUsersPage />
          </ProtectedRoute>
        } />
      </Route>
      
      <Route path="*" element={<Navigate to="/dashboard" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AppRoutes />
        <Toaster position="top-right" richColors />
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
